// extracted by mini-css-extract-plugin
export default {"-large":"yWDQ94SO1EviI_ZhnIoS","accountButton":"YxN1FcHwk6eRT2T0izA1","active":"cpF_4wJL7T9MHiVgcs01"};